import { Injectable }                        from "@angular/core";
import { CONFIGURATION }                     from "../../../app.constants";
import { User }            from "../../../models";
import { Observable }                        from "rxjs/Observable";
import { HttpDataService }                   from "../../../services/shared";

@Injectable()
export class UserDetailsService {
    // private userDetailsUpdate = new Subject<User>();

    constructor(private httpData: HttpDataService) { }

    public GetUserDetails(id: string): Observable<User> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}account/GetUserAsAdmin/${id}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <User>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetAllMyOrganisations(userId: string): Observable<User> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}GetAllMyOrganisations?userId=${userId}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <User>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetLinkedStatusForuser(userId: string): Observable<boolean> {

        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + `singlesignon/LinkStatus?userId=${userId}`)
                .map(response => response.json().result)
                .subscribe((userData) => { 
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/userDetails.service.ts